import * as React from "react";

import Input from "@common/designSystem/Input";
import LabeledControl from "@common/designSystem/LabeledControl";
import { ErrorMessage as GlobalErrorMessage } from "@components/account/common";
import GoogleAuth from "@components/account/GoogleAuth";

import Button from "@replo/design-system/components/button/Button";
import Separator from "@replo/design-system/components/Separator";

import { TermsAndPrivacy } from "./TermsAndPrivacy";
import { useSignupForm } from "./useSignupForm";

const SignupForm = () => {
  const {
    emailRegisterProps,
    passwordRegisterProps,
    handleSubmit,
    onSubmit,
    onGoogleSubmit,
    emailError,
    passwordError,
    isLoadingCreateAccount,
    buttonShouldBeDisabled,
    displayErrorMessage,
  } = useSignupForm();

  return (
    <form
      className="no-scrollbar"
      onSubmit={(data) => void handleSubmit(onSubmit)(data)}
    >
      <GlobalErrorMessage errorMessage={displayErrorMessage} />
      <div className="flex flex-col gap-4">
        <LabeledControl
          label="Email"
          className="text-default font-medium"
          size="base"
          id="email"
          error={emailError}
        >
          <Input
            id="email"
            validityState={emailError ? "invalid" : undefined}
            autoComplete="off"
            placeholder="Your Work Email"
            {...emailRegisterProps}
            type="email"
            size="base"
          />
        </LabeledControl>
        <LabeledControl
          label="Password"
          className="text-default font-medium"
          size="base"
          id="password"
          error={passwordError}
        >
          <Input
            id="password"
            validityState={passwordError ? "invalid" : undefined}
            autoComplete="off"
            placeholder="••••••••••••"
            {...passwordRegisterProps}
            type="password"
            size="base"
          />
        </LabeledControl>
      </div>
      <div className="mt-10">
        <TermsAndPrivacy />
      </div>
      <Button
        layoutClassName="mt-6 w-full"
        variant="primary"
        size="base"
        type="submit"
        isLoading={isLoadingCreateAccount}
        disabled={buttonShouldBeDisabled}
      >
        Create Account
      </Button>
      <Separator className="my-4" />
      <GoogleAuth width={370} handleGoogleCredentials={onGoogleSubmit} />
    </form>
  );
};

export default SignupForm;
